import { render } from "./FileExport.vue?vue&type=template&id=3a65abc8"
import script from "./FileExport.vue?vue&type=script&lang=js"
export * from "./FileExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__